import { State } from ".";

export const getIsCalendarOpen = (state: State): boolean =>
    state.ui.isCalendarOpen;
